import { render } from "./BookAccomodation.vue?vue&type=template&id=76acf503&scoped=true"
import script from "./BookAccomodation.vue?vue&type=script&lang=js"
export * from "./BookAccomodation.vue?vue&type=script&lang=js"

import "./BookAccomodation.vue?vue&type=style&index=0&id=76acf503&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76acf503"]])

export default __exports__